// Fix this issue https://github.com/vite-pwa/sveltekit/issues/63
// https://kit.svelte.dev/docs/page-options#prerender
// Keep the prerender !
export const prerender = 'auto'
